import { JsonBuilderServiceModel } from "../../Site/services/JsonBuilderService";
import { RootState, useAppDispatch, useAppSelector } from "../store";
import {
  updateAndSaveProperty as updateAndSavePropertyAction,
  updateProperty as updatePropertyAction,
  updateAppChangedStatus as updateAppChangedStatusAction,
  updateAllProperties as updateAllPropertiesAction,
  changeSavingStatus as changeSavingStatusAction,
} from '../slices/jsonSlice';
// Not every component needs to dispatch actions individually; therefore, we create a common hook to handle dispatching.
export const useUpdateJson = () => {
  const dispatch = useAppDispatch();
  function updateAndSaveProperty(path: string | string[], value: any) {
      dispatch(updateAndSavePropertyAction({ path, value }));
  }

  function updateProperty(path: string | string[], value: any) {
    dispatch(updatePropertyAction({ path, value }));
  }
  function updateAppChangedStatus(isChanged:boolean){
    dispatch(updateAppChangedStatusAction(isChanged));
  }
  function updateAllProperties(payload:JsonBuilderServiceModel){
    dispatch(updateAllPropertiesAction(payload));
  }
  function changeSavingStatus(payload:boolean){
    dispatch(changeSavingStatusAction(payload));
  }

  return {
    updateAndSaveProperty,
    updateProperty,
    updateAppChangedStatus,
    updateAllProperties,
    changeSavingStatus
  };
};

// custom hook for accessing the data
export const useAppState = () => {
  return {
    state: useAppSelector((state: RootState) => {
      return state.jsonObject.data;
    }),
    savingStatus: useAppSelector((state: RootState) => {
      return state.jsonObject.savingStatus;
    }),
    loadingStatus: useAppSelector((state: RootState) => {
      return state.jsonObject.loading;
    }),
  };
};